import * as actions from './actions'
import * as getters from './getters'

import {
  FETCH_USERS,
  FETCH_IDENTITY_TOKEN,
} from './mutation-types'

// initial state
const initialState = {
  users: [],
  identityToken: null,
};

// mutations
const mutations = {
  [FETCH_USERS] (state, users) {
    state.users = users;
  },

  [FETCH_IDENTITY_TOKEN] (state, token) {
    state.identityToken = token;
  },
};

export default {
  state: { ...initialState },
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/users/index.js